import { render } from "./SectionTopos.vue?vue&type=template&id=3f961d72"
import script from "./SectionTopos.vue?vue&type=script&lang=js"
export * from "./SectionTopos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__